import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Modal,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";

interface Props {
  open: boolean;
  handleClose: Function;
  successCallback: Function;
  data: string[];
  filterData: string[];
  name: string;
}

const FilterModal: React.FC<Props> = ({
  open,
  handleClose,
  successCallback,
  data,
  filterData,
  name,
}) => {
  const [selected, setSelected] = useState<string[]>(filterData);
  const [search, setSearch] = useState("");

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const itemName = event.target.name;
    setSelected((prevSelected) =>
      prevSelected.includes(itemName)
        ? prevSelected.filter((item) => item !== itemName)
        : [...prevSelected, itemName]
    );
  };

  const handleFilter = () => {
    successCallback(selected);
    handleClose();
  };

  const handleClear = () => {
    successCallback([]);
    setSelected([]);
    handleClose();
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(event.target.value);
    setSelected([]);
  };

  const filteredData = data.filter((item) =>
    item.toLowerCase().includes(search.toLowerCase())
  );
  return (
    <Modal open={open} onClose={() => handleClose()}>
      <Box
        position={"absolute" as "absolute"}
        top={"50%"}
        left={"50%"}
        bgcolor={"background.paper"}
        borderRadius={"22px"}
        sx={{ transform: "translate(-50%, -50%)" }}
        width={"25%"}
        p={3}
      >
        <Stack justifyContent={"space-between"} direction={"row"}>
          <Typography
            fontWeight={500}
            variant="h6"
            textAlign="center"
            marginBottom={2}
          >
            Filter {name}
          </Typography>
          <Button
            onClick={() => handleClose()}
            sx={{ height: "30px", width: "10px" }}
          >
            <CloseIcon fontSize="small" color="info" />
          </Button>
        </Stack>

        <Stack p={1}>
          <TextField
            label="Search"
            variant="outlined"
            fullWidth
            value={search}
            size="small"
            onChange={handleSearchChange}
          />
          <Stack spacing={2} height={"40vh"} overflow={"scroll"}>
            <FormControl component="fieldset" variant="standard">
              <FormGroup>
                {filteredData.map((item, index) => (
                  <FormControlLabel
                    key={index + 1}
                    control={
                      <Checkbox
                        onChange={handleChange}
                        name={item}
                        checked={
                          filterData.includes(item) || selected.includes(item)
                        }
                      />
                    }
                    label={item}
                  />
                ))}
              </FormGroup>
            </FormControl>
          </Stack>
        </Stack>

        <Stack justifyContent={"center"} direction={"row"} spacing={2}>
          <Button onClick={handleFilter} variant="contained">
            Filter
          </Button>
          <Button
            onClick={handleClear}
            variant="contained"
            sx={{ backgroundColor: "red" }}
          >
            Clear
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default FilterModal;
